import React from 'react'

import { Redirect } from 'react-router-dom'

import { getAccessToken } from '@driftt/web-auth'

import config from 'config/index'

const IFrameWrapper = ({ path, show, className = '' }) => {
  // Sanitize the hash to prevent XSS attacks
  const sanitizeHash = (hash) => {
    if (!hash) return ''

    // Remove any potentially dangerous characters and ensure it starts with #
    const cleanHash = hash.replace(/[<>"'&]/g, '')

    // Only allow hash if it starts with # and contains safe characters
    if (cleanHash.startsWith('#') && /^#[a-zA-Z0-9\-_=&.]*$/.test(cleanHash)) {
      return cleanHash
    }

    return ''
  }

  const hash = sanitizeHash(window.location.hash)

  return show ? (
    <iframe
      style={{
        height: '100%',
        width: '100%',
        border: 'none',
        padding: 0,
        margin: 0,
      }}
      allow="clipboard-write"
      id={`sc-${path}-iframe`}
      src={`${
        config.EXPERIENCES_WEB_URL
      }/${path}${hash}?accessToken=${getAccessToken()}`}
      title={path}
      className={className}
    />
  ) : (
    <Redirect to={'/settings2'} />
  )
}

export default IFrameWrapper
